import React from "react"
import ProductCard from "../components/product_card"

export const Catalog = ( { products } ) => {
    const renderItems = (items) => items.map( (product, i) => {
        return (
            <ProductCard key={i} product={ product.node } />
        )
    })

    return (
        <div className="container">
            <h3 className="almo-h3 py-20">
                Product Catalog
            </h3>
            <div className="row pb-50">
                { renderItems(products) }
            </div>
        </div>
    )
}

export default Catalog